var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFC107",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2571_782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2229 14H21.1063C19.1326 14 17.5 15.6242 17.5 17.5979V42.4022C17.5 44.3758 19.1326 46 21.1063 46H38.9092C40.8828 46 42.515 44.3758 42.515 42.4022V22.6984L34.2229 14Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2634 14.0244L42.5234 22.7064H37.0248C35.498 22.7064 34.2634 21.4721 34.2634 19.9453V14.0244Z",
    fill: "#E9B108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6918 39.5837H23.3233C22.8768 39.5837 22.5114 39.9492 22.5114 40.3958C22.5114 40.8427 22.8768 41.2082 23.3233 41.2082H36.7C37.1467 41.2082 37.5121 40.8427 37.5121 40.3958C37.5121 39.9492 37.1467 39.5837 36.6918 39.5837Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8494 30.8447L29.1955 27.2469V36.1156C29.1955 36.5625 29.5609 36.9279 30.0076 36.9279C30.4543 36.9279 30.8199 36.5625 30.8199 36.1156V27.2465L34.166 30.8447C34.3283 31.015 34.5394 31.1045 34.7588 31.1045C34.9539 31.1045 35.1566 31.0314 35.3113 30.8851C35.6359 30.5765 35.6603 30.0648 35.3517 29.74L30.6006 24.6312C30.4463 24.4689 30.2351 24.3715 30.0078 24.3715C29.7803 24.3715 29.5691 24.4689 29.4148 24.6312L24.6637 29.74C24.3551 30.0648 24.3795 30.5847 24.7041 30.8851C25.0291 31.1937 25.5406 31.1693 25.8494 30.8447Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2571_782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSvg);
export default __webpack_public_path__ + "static/media/UploadSvg.22c5de1852c6ae0922d21c7528732ca0.svg";
export { ForwardRef as ReactComponent };